import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  return String(detail);
}

export function waShareUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function statusLabel(s) {
  return ({
    new: "Open",
    acknowledged: "Acknowledged",
    assigned: "Assigned",
    in_progress: "In progress",
    resolved: "Resolved",
    closed: "Closed",
    reopened: "Reopened",
    pending: "Pending",
    done: "Done",
    cancelled: "Cancelled",
  })[s] || s;
}

export function pillClass(s) {
  return ({
    new: "pill pill-open",
    acknowledged: "pill pill-acknowledged",
    assigned: "pill pill-assigned",
    in_progress: "pill pill-progress",
    resolved: "pill pill-resolved",
    closed: "pill pill-closed",
    reopened: "pill pill-open",
    pending: "pill pill-open",
    done: "pill pill-resolved",
    cancelled: "pill pill-closed",
    overdue: "pill pill-overdue",
    low: "pill pill-low",
    medium: "pill pill-medium",
    high: "pill pill-high",
    urgent: "pill pill-urgent",
  })[s] || "pill pill-low";
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export function isOverdue(iso, status) {
  if (!iso || ["resolved", "closed", "done", "cancelled"].includes(status)) return false;
  return new Date(iso).getTime() < Date.now();
}
